import { render, staticRenderFns } from "./detail_coin.vue?vue&type=template&id=570f48f8&"
import script from "./detail_coin.vue?vue&type=script&lang=js&"
export * from "./detail_coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailInfosection: require('/src/components/detail/desktop/detail_infosection.vue').default,DetailMoreInfosection: require('/src/components/detail/desktop/detail_more_infosection.vue').default})
